export const types = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',

    uiSetError: '[UI] Set Error',
    uiRemoveError: '[UI] Remove Error',

    uiStartLoading: '[UI] Start Loading',
    uiFinishLoading: '[UI] Finish Loading',

    notesAddNew: '[Notes] Add New Note',
    notesSetActive: '[Notes] Set Active Note',
    notesLoad: '[Notes] Load Notes',
    notesUpdate: '[Notes] Update Note',
    notesDelete: '[Notes] Delete Note',
    notesImgUrl: '[Notes] Load Image Url',
    notesCleaning: '[Notes] Logout Cleaning'
}